<div class="container">
  <div *ngIf="isIdleLogout$ | async; else isManualLogout">
    <p> You have been logged out due to inactivity.</p>
  </div>
  <ng-template #isManualLogout>You have successfully logged out.</ng-template>
  <div class="login-button">
    <button mat-flat-button type="button" color="primary" [routerLink]="['/']">Log Back In</button>
  </div>
</div>